/* Mamacita in Pink — theme JavaScript */

/* ===== Predictive search (header) =====
   Desktop: hover the icon opens the panel. Mobile: tap opens it.
   Uses Shopify's public predictive search JSON endpoint — no page
   navigation needed until the customer picks a result or hits Enter. */
(function () {
  var wrap, panel, input, results, debounceTimer;

  function ensureRefs() {
    wrap = wrap || document.getElementById('mipPsearch');
    panel = panel || document.getElementById('mipPsearchPanel');
    input = input || document.getElementById('mipPsearchInput');
    results = results || document.getElementById('mipPsearchResults');
  }

  window.toggleSearch = function (e) {
    if (e) e.preventDefault();
    ensureRefs();
    if (!wrap) return;
    var isOpen = wrap.classList.contains('open');
    if (isOpen) { closeSearchPanel(); } else { openSearchPanel(); }
  };
  function openSearchPanel() {
    ensureRefs();
    if (!wrap) return;
    wrap.classList.add('open');
    wrap.querySelector('.icon-btn').setAttribute('aria-expanded', 'true');
    setTimeout(function () { input && input.focus(); }, 60);
  }
  function closeSearchPanel() {
    ensureRefs();
    if (!wrap) return;
    wrap.classList.remove('open');
    wrap.querySelector('.icon-btn').setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureRefs();
    if (!wrap) return;

    /* Desktop: open on hover */
    if (window.matchMedia('(hover: hover) and (min-width: 900px)').matches) {
      wrap.addEventListener('mouseenter', openSearchPanel);
      wrap.addEventListener('mouseleave', closeSearchPanel);
    }

    input && input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () { runPredictiveSearch(q); }, 220);
    });

    document.addEventListener('click', function (e) {
      /* The mobile bottom-nav's Search button lives outside #mipPsearch
         (it's a separate trigger elsewhere in the DOM), so a click on it
         bubbles to this same document listener right after toggleSearch()
         just opened the panel — without this exclusion, that click would
         look like an "outside click" and instantly close the panel again
         on the same tap. Any element that itself opens search is exempt. */
      if (e.target.closest('[onclick*="toggleSearch"]')) return;
      if (wrap.classList.contains('open') && !wrap.contains(e.target)) closeSearchPanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearchPanel();
    });
  });

  function runPredictiveSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderResults(data && data.resources && data.resources.results ? data.resources.results : {});
      })
      .catch(function () {});
  }

  function moneyFmt(amount) {
    /* Shopify's /search/suggest.json returns price as a decimal string
       (e.g. "2500.00"), NOT cents — unlike routes.product_recommendations_url
       or the Storefront API's variant.price (money_v2 cents-style values).
       Do not divide by 100 here. */
    try {
      var n = parseFloat(amount);
      if (isNaN(n)) return amount;
      return n.toLocaleString(undefined, { style: 'currency', currency: window.shopCurrency || 'KES' });
    } catch (e) { return amount; }
  }

  function renderResults(r) {
    ensureRefs();
    var html = '';
    var products = (r.products || []);
    var collections = (r.collections || []);
    var queries = (r.queries || []);

    if (!products.length && !collections.length) {
      html = '<div class="mip-psr-empty">No matches yet — try a product, brand, or category 💕</div>';
    } else {
      if (queries.length) {
        html += '<div class="mip-psr-heading">Try searching</div>';
        queries.forEach(function (q) {
          html += '<a class="mip-psr-item" href="' + q.url + '"><span class="mip-psr-name">' + q.text + '</span></a>';
        });
      }
      if (collections.length) {
        html += '<div class="mip-psr-heading">Categories</div>';
        collections.forEach(function (c) {
          html += '<a class="mip-psr-item" href="' + c.url + '"><span class="mip-psr-name">' + c.title + '</span></a>';
        });
      }
      if (products.length) {
        html += '<div class="mip-psr-heading">Products</div>';
        products.forEach(function (p) {
          var img = p.image ? p.image : '';
          html += '<a class="mip-psr-item" href="' + p.url + '">' +
            (img ? '<img class="mip-psr-img" src="' + img + '" alt="">' : '<span class="mip-psr-img"></span>') +
            '<span class="mip-psr-name">' + p.title + '</span>' +
            '<span class="mip-psr-price">' + moneyFmt(p.price) + '</span></a>';
        });
      }
    }
    results.innerHTML = html;
    results.hidden = false;
  }
})();

function openMenu() { document.body.classList.add('drawer-open', 'menu-open'); }
function openFilter() { document.body.classList.add('drawer-open', 'filter-open'); }
function closeDrawers() { document.body.classList.remove('drawer-open', 'menu-open', 'filter-open', 'cart-open'); }

/* ===== Announcement slider ===== */
var annIdx = 0;
function annSlide(d) {
  var s = document.querySelectorAll('.ann-slide');
  if (!s.length) return;
  annIdx = (annIdx + d + s.length) % s.length;
  s.forEach(function (el, i) { el.classList.toggle('active', i === annIdx); });
}
setInterval(function () { annSlide(1); }, 5000);

/* ===== Carousel arrows ===== */
function slideCar(id, d) {
  var el = document.getElementById(id);
  if (el) el.scrollBy({ left: d * el.clientWidth * 0.75, behavior: 'smooth' });
}

/* ===== Shoppable video modal ===== */
function openVideo(btn) {
  var modal = document.getElementById('videoModal');
  var tpl = document.getElementById(btn.dataset.target);
  if (!modal || !tpl) return;
  document.getElementById('vmContent').innerHTML = tpl.innerHTML;
  modal.hidden = false;
  document.body.style.overflow = 'hidden';
  /* Nothing plays yet — the modal opens on the cover/poster (never
     blank: manual cover image, or a themed gradient placeholder). Actual
     playback (video or Instagram embed) only starts once the shopper
     taps that poster — see mipPlayMedia below. */
}

/* Tapping an uploaded-video tile's poster inside the modal: reveal +
   play the real video. (Instagram tiles never reach this — they open
   Instagram directly from the tile itself, and their "Shop" popup only
   ever shows a plain "Watch on Instagram" link, no embed attempt, so
   watching a Reel is always a guaranteed-to-work new-tab open rather
   than a fragile in-page embed.) */
function mipPlayMedia(posterBtn) {
  var wrap = posterBtn.parentElement;
  var media = wrap.querySelector('.vm-media');
  if (!media) return;
  posterBtn.hidden = true;
  media.hidden = false;
  var video = media.querySelector('video');
  if (video) video.play();
}
function closeVideo() {
  var modal = document.getElementById('videoModal');
  if (!modal) return;
  var v = modal.querySelector('video');
  if (v) v.pause();
  modal.hidden = true;
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeVideo(); closeWlModal(); } });

/* ===== Footer accordion (mobile) ===== */
document.addEventListener('click', function (e) {
  var h = e.target.closest('.footer-col.collapsible h4');
  if (h && window.innerWidth < 900) h.parentElement.classList.toggle('open');
});

/* ===== Wishlist =====
   Hearts save products to this browser (localStorage). For wishlists that
   follow the customer across devices, add a wishlist app — this gives a
   lovely basic experience in the meantime. */
var WL_KEY = 'mip_wishlist';
function wlGet() {
  try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
}
function wlSet(list) {
  try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
}

/* Heart buttons on product cards */
document.addEventListener('click', function (e) {
  var w = e.target.closest('.wishlist');
  if (!w) return;
  e.preventDefault();
  var handle = w.dataset.handle;
  if (!handle) { w.textContent = w.textContent === '♡' ? '💗' : '♡'; return; }
  var list = wlGet();
  var i = list.indexOf(handle);
  if (i > -1) { list.splice(i, 1); w.textContent = '♡'; }
  else { list.push(handle); w.textContent = '💗'; }
  wlSet(list);
});

/* Show saved state on page load */
document.addEventListener('DOMContentLoaded', function () {
  var list = wlGet();
  document.querySelectorAll('.wishlist[data-handle]').forEach(function (w) {
    if (list.indexOf(w.dataset.handle) > -1) w.textContent = '💗';
  });
});

/* Header heart: signed in -> wishlist page, guests -> branded popup */
function wishlistClick(e) {
  e.preventDefault();
  if (window.customerLoggedIn) {
    window.location.href = window.wishlistUrl || '/pages/wishlist';
    return;
  }
  openWlModal();
}
function openWlModal() {
  if (!document.getElementById('wlModal')) {
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="welcome-pop" id="wlModal">' +
      '<div class="vm-backdrop" onclick="closeWlModal()"></div>' +
      '<div class="wp-card wp-fancy">' +
      '<button class="icon-btn vm-close" onclick="closeWlModal()" aria-label="Close">✕</button>' +
      '<div class="wp-heart">💗</div>' +
      '<h3>Sign in to save your faves 💕</h3>' +
      '<p style="font-size:14px;color:var(--text-soft);margin-bottom:16px;">Create an account or sign in to keep your wishlist safe and come back to your beauty picks anytime.</p>' +
      '<div style="display:flex;flex-direction:column;gap:8px;">' +
      '<a class="btn btn-pink btn-block" href="' + (window.accountLoginUrl || '/account/login') + '">Sign In</a>' +
      '<a class="btn btn-outline btn-block" href="' + (window.accountRegisterUrl || '/account/register') + '">Create Account</a>' +
      '<button class="btn btn-block" style="background:none;color:var(--text-soft);text-decoration:underline;font-size:12px;min-height:38px;" onclick="closeWlModal()">Keep Browsing</button>' +
      '</div></div></div>';
    document.body.appendChild(wrap.firstElementChild);
  }
  document.getElementById('wlModal').hidden = false;
  document.body.style.overflow = 'hidden';
}
function closeWlModal() {
  var m = document.getElementById('wlModal');
  if (m) m.hidden = true;
  if (!document.querySelector('.welcome-pop:not([hidden])')) document.body.style.overflow = '';
}

/* ===================== Cart drawer ===================== */
var FREE_SHIP_KES = 5000;

function kes(cents) { return 'KSh ' + Math.round(cents / 100).toLocaleString(); }

function openCart(e) {
  if (e) e.preventDefault();
  refreshCart();
  document.body.classList.add('drawer-open', 'cart-open');
}

/* Intercept every add to cart form so the drawer opens instantly */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.action || form.action.indexOf('/cart/add') === -1) return;
  e.preventDefault();
  var btn = form.querySelector('[type="submit"]');
  fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (btn) { var old = btn.textContent; btn.textContent = '✓ Added!'; setTimeout(function () { btn.textContent = old; }, 1200); }
      openCart();
    })
    .catch(function () { form.submit(); }); /* graceful fallback to normal flow */
});

function refreshCart() {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
}

function renderCart(cart) {
  /* header badge: hidden when empty, quantity when not */
  document.querySelectorAll('.cart-count').forEach(function (c) {
    c.textContent = cart.item_count;
    c.hidden = cart.item_count === 0;
  });
  var count = document.getElementById('cdCount');
  if (!count) return; /* drawer not on this page */
  count.textContent = cart.item_count;

  /* free delivery progress */
  var subtotal = cart.items_subtotal_price; /* cents */
  var threshold = FREE_SHIP_KES * 100;
  var pct = Math.min(100, Math.round(subtotal / threshold * 100));
  document.getElementById('cdProgress').style.width = pct + '%';
  var note = document.getElementById('cdShipNote');
  if (subtotal >= threshold) {
    note.textContent = "Yay! You've unlocked free delivery 🎉";
  } else {
    note.textContent = "You're only " + kes(threshold - subtotal) + ' away from free delivery 💕';
  }

  /* items */
  var wrap = document.getElementById('cdItems');
  var empty = document.getElementById('cdEmpty');
  var summary = document.getElementById('cdSummary');
  if (cart.item_count === 0) {
    wrap.innerHTML = '';
    empty.hidden = false;
    summary.style.display = 'none';
    return;
  }
  empty.hidden = true;
  summary.style.display = '';
  wrap.innerHTML = cart.items.map(function (item, i) {
    var line = i + 1;
    var img = item.image ? '<img class="cdi-img" src="' + item.image + '" alt="" loading="lazy">' : '<span class="cdi-img"></span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cdi-variant">' + item.variant_title + '</p>' : '';
    return '<div class="cd-item">' + img +
      '<div class="cdi-info">' +
      '<p class="cdi-name"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
      variant +
      '<p class="cdi-price">' + kes(item.final_line_price) + '</p>' +
      '<div class="cdi-row">' +
      '<span class="qty-stepper">' +
      '<button type="button" onclick="cdQty(' + line + ',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
      '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
      '<button type="button" onclick="cdQty(' + line + ',' + (item.quantity + 1) + ')" aria-label="Increase">＋</button>' +
      '</span>' +
      '<button class="cdi-remove" onclick="cdQty(' + line + ',0)">Remove</button>' +
      '</div></div></div>';
  }).join('');
  document.getElementById('cdSubtotal').textContent = kes(subtotal);
}

function cdQty(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  }).then(function (r) { return r.json(); }).then(renderCart);
}

/* ===== Delivery / pickup selection (progressive, one step at a time) ===== */
/* ---- Nairobi clock + date formatting ----------------------------------
   All same-day cutoffs run on Africa/Nairobi time, corrected against
   Shopify's own server clock (Date header on /cart.js) so a wrong device
   clock or timezone can't be used to sneak past a cutoff. */
var MIP_TZ = 'Africa/Nairobi';
var MIP_CLOCK_SKEW = 0;
function mipSyncClock() {
  return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
    var h = r.headers.get('Date');
    if (h && !isNaN(Date.parse(h))) MIP_CLOCK_SKEW = Date.parse(h) - Date.now();
    return r.json();
  });
}
function mipNairobiNow() {
  var p = {};
  new Intl.DateTimeFormat('en-GB', { timeZone: MIP_TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(new Date(Date.now() + MIP_CLOCK_SKEW)).forEach(function (x) { p[x.type] = x.value; });
  return { iso: p.year + '-' + p.month + '-' + p.day, y: +p.year, m: +p.month - 1, d: +p.day, minutes: (+p.hour % 24) * 60 + (+p.minute), stamp: p.year + '-' + p.month + '-' + p.day + ' ' + p.hour + ':' + p.minute };
}
/* Nairobi "today" as a local midnight Date (for calendar comparisons) */
function mipNairobiToday() { var n = mipNairobiNow(); return new Date(n.y, n.m, n.d); }
function cdIso(dt) {
  return dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
}
/* "2026-10-05" -> "Monday, 5th Oct 2026" (weekday computed from the date itself) */
function mipFormatLongDate(iso) {
  var p = String(iso).split('-'); if (p.length !== 3) return iso;
  var dt = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
  var wd = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dt.getUTCDay()];
  var mo = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+p[1] - 1];
  var n = +p[2], suf = (n % 100 >= 11 && n % 100 <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
  return wd + ', ' + n + suf + ' ' + mo + ' ' + p[0];
}
/* Ordering cutoffs (Nairobi time). Defaults 10:00 and 16:00; editable in
   Theme Editor -> Header group -> Blocked Dates. */
function mipCutoffMinutes(key, fallback) {
  var el = document.getElementById('mip-delivery-cutoffs'), v = '';
  try { v = (JSON.parse(el.textContent) || {})[key] || ''; } catch (e) {}
  var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(v);
  if (!m) return fallback;
  return (+m[1]) * 60 + (+m[2]);
}
var CD_SLOT_KEYS = { '11:00 AM – 5:00 PM': '11am-5pm', '5:00 PM – 8:00 PM': '5pm-8pm' };
function cdSlotsFor(dateStr) {
  var day = new Date(dateStr + 'T12:00:00').getDay();
  var weekend = (day === 0 || day === 6);
  var all = weekend ? ['1:00 PM – 3:00 PM'] : ['11:00 AM – 5:00 PM', '5:00 PM – 8:00 PM'];
  var now = mipNairobiNow();
  if (dateStr < now.iso) return [];
  /* Same-day cutoffs (Nairobi time). An order at exactly 10:00 still
     qualifies; 10:01 does not. Same rule for the 5 PM–8 PM slot at 4:00 PM. */
  if (dateStr === now.iso) {
    var cut = {
      '11:00 AM – 5:00 PM': mipCutoffMinutes('first_slot', 600),
      '5:00 PM – 8:00 PM': mipCutoffMinutes('second_slot', 960),
      '1:00 PM – 3:00 PM': mipCutoffMinutes('weekend_slot', null)
    };
    all = all.filter(function (label) { return cut[label] === null || now.minutes <= cut[label]; });
  }
  /* Remove any slot Alix has blocked for just this date via the Theme
     Editor's Blocked Dates section (a whole-day block already keeps the
     date itself from being selected in the calendar — see mipIsBlocked). */
  var blockedSlots = mipBlockedSlots(dateStr);
  if (!blockedSlots.length) return all;
  return all.filter(function (label) {
    var key = CD_SLOT_KEYS[label];
    return !key || blockedSlots.indexOf(key) === -1;
  });
}
function cdFillSlots(dateInputId, slotSelectId) {
  var date = document.getElementById(dateInputId).value;
  var sel = document.getElementById(slotSelectId);
  if (!date) { sel.innerHTML = '<option value="">Pick a date first</option>'; return; }
  var slots = cdSlotsFor(date);
  sel.innerHTML = slots.length
    ? slots.map(function (s) { return '<option>' + s + '</option>'; }).join('')
    : '<option value="">No time slots left for this date — pick another date</option>';
}
function cdAddWorkingDays(date, days) {
  var d = new Date(date);
  while (days > 0) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== 0) days--;
  }
  return d;
}
function cdPretty(d) {
  return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
}

document.addEventListener('change', function (e) {
  /* One choice reveals only what's relevant */
  if (e.target.name === 'cdMethod') {
    ['cdNairobi', 'cdCourier', 'cdPickup'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.hidden = true;
    });
    var map = { 'Nairobi Delivery': 'cdNairobi', 'Countrywide Delivery': 'cdCourier', 'Pickup': 'cdPickup' };
    var show = document.getElementById(map[e.target.value]);
    if (show) show.hidden = false;
    cdWarn('');
  }

  if (e.target.id === 'cdNbDate') cdFillSlots('cdNbDate', 'cdNbSlot');

  /* Gift toggle */
  if (e.target.id === 'cdGift') {
    document.getElementById('cdGiftFields').hidden = !e.target.checked;
  }

  /* Courier: no Sundays + show the fulfilment window */
  if (e.target.id === 'cdCoDate') {
    var eta = document.getElementById('cdCoEta');
    var d = new Date(e.target.value + 'T12:00:00');
    if (d.getDay() === 0) {
      cdWarn('Couriers do not deliver on Sundays — please pick another date 💕');
      e.target.value = '';
      eta.hidden = true;
    } else {
      cdWarn('');
      var from = cdAddWorkingDays(d, 1), to = cdAddWorkingDays(d, 2);
      eta.textContent = '📦 Estimated arrival: ' + cdPretty(from) + ' – ' + cdPretty(to);
      eta.hidden = !e.target.value;
    }
  }

  /* Pickup: choosing a location reveals the date, with the right minimum
     and method (each pickup location has its own blocked-dates method key) */
  if (e.target.name === 'cdPuLoc') {
    document.querySelectorAll('.pu-card').forEach(function (c) {
      c.classList.toggle('active', c.contains(e.target));
    });
    var dateWrap = document.getElementById('cdPuDateWrap');
    var dateInput = document.getElementById('cdPuDate');
    var trig = document.getElementById('cdPuDateBtn');
    var offsetDays = e.target.dataset.min === 'tomorrow' ? 1 : 0;
    trig.dataset.method = e.target.dataset.method || 'pickup-lavington';
    trig.dataset.minOffsetDays = offsetDays;
    var min = mipNairobiToday(); min.setDate(min.getDate() + offsetDays);
    if (dateInput.value && new Date(dateInput.value + 'T12:00:00') < min) {
      dateInput.value = '';
      trig.textContent = 'Select date';
      trig.classList.add('is-empty');
    }
    dateWrap.hidden = false;
  }
});

function cdWarn(msg) {
  var w = document.getElementById('cdWarn');
  if (!w) return;
  w.textContent = msg;
  w.hidden = !msg;
}

/* Save fulfilment details as cart attributes, then go to checkout.
   These attributes appear on the order in Shopify admin ("Additional details").
   The date is saved as a full, human-readable date ("Monday, 5th Oct 2026",
   weekday calculated from the date itself) plus a sortable YYYY-MM-DD copy.
   Everything is re-validated against Shopify's server clock right before
   checkout, so a slot that closed while the drawer was open can't go through. */
function cdResetDate(btnId, inputId, label) {
  var i = document.getElementById(inputId), b = document.getElementById(btnId);
  if (i) i.value = '';
  if (b) { b.textContent = label || 'Select date'; b.classList.add('is-empty'); }
}
function cdCheckout() {
  var method = document.querySelector('input[name="cdMethod"]:checked');
  if (!method) { cdWarn("Please choose how you'd like to receive your order 💕"); return; }
  var btn = document.getElementById('cdCheckout');
  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'One sec, girly…';
  function stop(msg) { btn.disabled = false; btn.textContent = original; cdWarn(msg); }

  mipSyncClock().catch(function () {}).then(function () {
    var attrs = { 'Fulfilment method': method.value };
    var note = '';
    var now = mipNairobiNow();
    if (method.value === 'Nairobi Delivery') {
      var d = document.getElementById('cdNbDate').value, s = document.getElementById('cdNbSlot').value;
      if (!d || !s) return stop('Please pick your delivery date and time slot 💕');
      var blocked = mipIsBlocked(d, 'nairobi');
      if (blocked || cdSlotsFor(d).indexOf(s) === -1) {
        /* Slot/date no longer valid (cutoff passed or blocked) — refresh and ask again */
        cdFillSlots('cdNbDate', 'cdNbSlot');
        if (!cdSlotsFor(d).length) cdResetDate('cdNbDateBtn', 'cdNbDate');
        return stop(blocked ? 'Sorry girly, ' + blocked.toLowerCase() + ' on that date — please pick another 💕'
                            : 'That delivery slot has just closed for ordering — please choose another slot or date 💕');
      }
      attrs['Delivery date'] = mipFormatLongDate(d);
      attrs['Delivery date (sortable)'] = d;
      attrs['Time slot'] = s;
      attrs['Slot validated (Nairobi time)'] = now.stamp;
      if (document.getElementById('cdGift').checked) {
        attrs['Gift'] = 'Yes';
        var gn = document.getElementById('cdGiftName').value, gm = document.getElementById('cdGiftMsg').value;
        if (gn) attrs['Gift recipient'] = gn;
        if (gm) { attrs['Gift message'] = gm; note = 'Gift message: ' + gm; }
      }
    } else if (method.value === 'Countrywide Delivery') {
      var cd = document.getElementById('cdCoDate').value;
      if (!cd) return stop('Please pick your preferred dispatch date 💕');
      if (cd < now.iso || mipIsBlocked(cd, 'countrywide')) { cdResetDate('cdCoDateBtn', 'cdCoDate'); return stop('That dispatch date is no longer available — please pick another 💕'); }
      attrs['Dispatch date'] = mipFormatLongDate(cd);
      attrs['Dispatch date (sortable)'] = cd;
    } else {
      var loc = document.querySelector('input[name="cdPuLoc"]:checked');
      if (!loc) return stop('Please choose a pickup location 💕');
      var pd = document.getElementById('cdPuDate').value;
      if (!pd) return stop('Please pick your pickup date 💕');
      if (pd < now.iso || mipIsBlocked(pd, loc.dataset.method || 'pickup-lavington')) { cdResetDate('cdPuDateBtn', 'cdPuDate'); return stop('That pickup date is no longer available — please pick another 💕'); }
      attrs['Pickup location'] = loc.value;
      attrs['Pickup date'] = mipFormatLongDate(pd);
      attrs['Pickup date (sortable)'] = pd;
    }
    cdWarn('');
    /* Blank out any older keys so a previous selection can't linger on the order */
    ['Delivery date', 'Delivery date (sortable)', 'Time slot', 'Slot validated (Nairobi time)', 'Dispatch date', 'Dispatch date (sortable)', 'Pickup location', 'Pickup date', 'Pickup date (sortable)', 'Gift', 'Gift recipient', 'Gift message'].forEach(function (k) {
      if (!(k in attrs)) attrs[k] = '';
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs, note: note })
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  });
}

/* ---- Stale-selection guard ---------------------------------------------
   If a delivery slot saved in the cart has since passed its cutoff (customer
   picked at 9 AM, came back at 11 AM, or went straight to the cart page),
   clear it so it can't ride along to checkout. Runs on page load, every
   minute, and before the cart page's own Check Out button. */
function mipSlotStillValid(attrs) {
  if (!attrs || attrs['Fulfilment method'] !== 'Nairobi Delivery') return true;
  var d = attrs['Delivery date (sortable)'], s = attrs['Time slot'];
  if (!d || !s) return true;
  return cdSlotsFor(d).indexOf(s) !== -1 && !mipIsBlocked(d, 'nairobi');
}
function mipGuardCart() {
  return mipSyncClock().then(function (cart) {
    if (mipSlotStillValid(cart.attributes)) return true;
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery date': '', 'Delivery date (sortable)': '', 'Time slot': '', 'Slot validated (Nairobi time)': '' } })
    }).then(function () {
      var i = document.getElementById('cdNbDate');
      if (i && i.value) { cdFillSlots('cdNbDate', 'cdNbSlot'); if (!cdSlotsFor(i.value).length) cdResetDate('cdNbDateBtn', 'cdNbDate'); }
      cdWarn('Your delivery slot has closed for ordering — please choose a new delivery date and time slot 💕');
      return false;
    });
  }).catch(function () { return true; });
}
document.addEventListener('DOMContentLoaded', function () {
  mipGuardCart();
  setInterval(mipGuardCart, 60000);
  /* Cart page Check Out button (it has no date picker of its own) */
  var cartCheckout = document.querySelector('form[action$="/cart"] [name="checkout"]');
  if (cartCheckout) cartCheckout.addEventListener('click', function (e) {
    var form = cartCheckout.form;
    if (form.dataset.mipChecked) return;
    e.preventDefault();
    mipGuardCart().then(function (ok) {
      if (!ok) { if (typeof openCart === 'function') openCart(); return; }
      form.dataset.mipChecked = '1';
      form.requestSubmit ? form.requestSubmit(cartCheckout) : form.submit();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  refreshCart();
});

/* ===================== Blocked Dates ===================== */
/* Read once from the invisible "Blocked Dates" section (editable in the
   Theme Editor — no code). Each entry:
   { date: "YYYY-MM-DD", method, slot: "all" | "11am-5pm" | "5pm-8pm", message } */
function mipLoadBlockedDates() {
  try {
    var el = document.getElementById('mip-blocked-dates');
    if (!el) return [];
    return JSON.parse(el.textContent) || [];
  } catch (e) { return []; }
}
var MIP_BLOCKED = mipLoadBlockedDates();

function mipIsBlocked(dateIso, method) {
  for (var i = 0; i < MIP_BLOCKED.length; i++) {
    var b = MIP_BLOCKED[i];
    if (b.date !== dateIso) continue;
    if (b.method !== 'all' && b.method !== method) continue;
    /* Only a whole-day block (slot "all"/blank) disables the date itself
       in the calendar. A single-slot block (e.g. just 11am-5pm) still
       leaves the date selectable — cdSlotsFor() removes just that slot
       from the Nairobi time-slot dropdown instead. */
    if (!b.slot || b.slot === 'all') return b.message || 'Unavailable';
  }
  return null;
}

/* Which Nairobi time slots (if any) are blocked for a specific date,
   regardless of whether the whole date is also blocked. */
function mipBlockedSlots(dateIso) {
  var slots = [];
  for (var i = 0; i < MIP_BLOCKED.length; i++) {
    var b = MIP_BLOCKED[i];
    if (b.date === dateIso && (b.method === 'all' || b.method === 'nairobi') && b.slot && b.slot !== 'all') {
      slots.push(b.slot);
    }
  }
  return slots;
}

/* ===================== Custom calendar (date picker) =====================
   Replaces the native <input type="date"> so blocked dates can be visibly
   disabled (native date pickers can't do this). One shared popover is
   reused for every date field in the cart drawer. */
var mipCal = { trigger: null, targetInput: null, method: '', noSundays: false, minDate: null, viewYear: 0, viewMonth: 0 };

function mipOpenCalendar(trigger) {
  mipCal.trigger = trigger;
  mipCal.targetInput = document.getElementById(trigger.dataset.target);
  mipCal.method = trigger.dataset.method || 'all';
  mipCal.noSundays = trigger.dataset.noSundays === 'true';

  var min = mipNairobiToday();
  min.setDate(min.getDate() + (parseInt(trigger.dataset.minOffsetDays, 10) || 0));
  mipCal.minDate = min;

  var current = mipCal.targetInput.value ? new Date(mipCal.targetInput.value + 'T12:00:00') : new Date(min);
  mipCal.viewYear = current.getFullYear();
  mipCal.viewMonth = current.getMonth();

  mipRenderCalendar();
  var pop = document.getElementById('mipCalPop');
  pop.hidden = false;
  mipPositionCalendar(trigger);
  setTimeout(function () { document.addEventListener('click', mipCalOutsideClick); }, 0);
}

function mipPositionCalendar(trigger) {
  var pop = document.getElementById('mipCalPop');
  var rect = trigger.getBoundingClientRect();
  var popWidth = 270, popHeight = 320;
  var left = Math.min(rect.left, window.innerWidth - popWidth - 10);
  var top = rect.bottom + 6;
  if (top + popHeight > window.innerHeight) top = Math.max(10, rect.top - popHeight - 6);
  pop.style.top = top + 'px';
  pop.style.left = Math.max(10, left) + 'px';
}

function mipCalOutsideClick(e) {
  var pop = document.getElementById('mipCalPop');
  if (pop.contains(e.target) || e.target === mipCal.trigger) return;
  mipCloseCalendar();
}
function mipCloseCalendar() {
  var pop = document.getElementById('mipCalPop');
  if (pop) pop.hidden = true;
  document.removeEventListener('click', mipCalOutsideClick);
}

function mipRenderCalendar() {
  var y = mipCal.viewYear, m = mipCal.viewMonth;
  var first = new Date(y, m, 1);
  var startDay = first.getDay();
  var daysInMonth = new Date(y, m + 1, 0).getDate();
  document.getElementById('mipCalTitle').textContent = first.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

  var todayIso = mipNairobiNow().iso;
  var selectedIso = mipCal.targetInput.value;
  var nextAvailableIso = null;
  var html = '';
  for (var i = 0; i < startDay; i++) html += '<span class="mip-cal-day is-blank"></span>';

  for (var d = 1; d <= daysInMonth; d++) {
    var dateObj = new Date(y, m, d);
    var iso = cdIso(dateObj);
    var disabled = false, reason = '';
    if (dateObj < mipCal.minDate) disabled = true;
    if (!disabled && mipCal.noSundays && dateObj.getDay() === 0) { disabled = true; reason = 'Couriers do not deliver on Sundays'; }
    if (!disabled) {
      var msg = mipIsBlocked(iso, mipCal.method);
      if (msg) { disabled = true; reason = msg; }
    }
    if (!disabled && mipCal.method === 'nairobi' && cdSlotsFor(iso).length === 0) {
      disabled = true;
      reason = (iso === todayIso) ? 'Same-day delivery cutoff has passed' : 'No delivery slots available';
    }
    if (!disabled && !nextAvailableIso) nextAvailableIso = iso;

    var cls = 'mip-cal-day';
    if (iso === todayIso) cls += ' is-today';
    if (iso === selectedIso) cls += ' is-selected';
    html += '<button type="button" class="' + cls + '"' +
      (disabled ? ' disabled title="' + (reason || 'Unavailable').replace(/"/g, '') + '"' : ' onclick="mipSelectCalDate(\'' + iso + '\')"') +
      '>' + d + '</button>';
  }
  document.getElementById('mipCalGrid').innerHTML = html;

  var note = document.getElementById('mipCalNextNote');
  if (nextAvailableIso) {
    var nd = new Date(nextAvailableIso + 'T12:00:00');
    note.textContent = 'Next available: ' + cdPretty(nd);
  } else {
    note.textContent = 'No available dates this month';
  }
}

function mipSelectCalDate(iso) {
  mipCal.targetInput.value = iso;
  mipCal.targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  var trig = mipCal.trigger;
  trig.textContent = cdPretty(new Date(iso + 'T12:00:00'));
  trig.classList.remove('is-empty');
  mipCloseCalendar();
}

document.addEventListener('click', function (e) {
  var trig = e.target.closest('.mip-date-trigger');
  if (trig) { e.stopPropagation(); mipOpenCalendar(trig); }
});
document.addEventListener('DOMContentLoaded', function () {
  var prev = document.getElementById('mipCalPrev');
  var next = document.getElementById('mipCalNext');
  if (prev) prev.addEventListener('click', function (e) {
    e.stopPropagation();
    mipCal.viewMonth--; if (mipCal.viewMonth < 0) { mipCal.viewMonth = 11; mipCal.viewYear--; }
    mipRenderCalendar();
  });
  if (next) next.addEventListener('click', function (e) {
    e.stopPropagation();
    mipCal.viewMonth++; if (mipCal.viewMonth > 11) { mipCal.viewMonth = 0; mipCal.viewYear++; }
    mipRenderCalendar();
  });
});

/* ===================== Share sheet (Share Cart + Share Wishlist) ===================== */
function mipOpenShareSheet(opts) {
  document.getElementById('mipShareTitle').textContent = opts.title;
  var toast = document.getElementById('mipShareToast');
  toast.hidden = true;

  document.getElementById('mipShareCopy').onclick = function () {
    var done = function () { toast.textContent = opts.toastText; toast.hidden = false; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(opts.url).then(done).catch(function () { window.prompt('Copy this link:', opts.url); });
    } else {
      window.prompt('Copy this link:', opts.url);
    }
  };

  document.getElementById('mipShareWa').href = 'https://wa.me/?text=' + encodeURIComponent(opts.waText);

  var nativeBtn = document.getElementById('mipShareNative');
  if (navigator.share) {
    nativeBtn.hidden = false;
    nativeBtn.onclick = function () { navigator.share({ title: opts.title, url: opts.url }).catch(function () {}); };
  } else {
    nativeBtn.hidden = true;
  }

  document.getElementById('mipShareSheet').hidden = false;
  document.body.style.overflow = 'hidden';
}
function mipCloseShareSheet() {
  var sheet = document.getElementById('mipShareSheet');
  if (sheet) sheet.hidden = true;
  if (!document.querySelector('.welcome-pop:not([hidden])')) document.body.style.overflow = '';
}

/* Share Cart — uses Shopify's native cart permalink (/cart/{variant}:{qty},...)
   so opening the link adds the same products/variants/quantities to a fresh
   cart. No customer or account data is included. */
function mipShareCart() {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    if (!cart.items.length) return;
    var parts = cart.items.map(function (it) { return it.id + ':' + it.quantity; });
    var url = window.location.origin + '/cart/' + parts.join(',');
    mipOpenShareSheet({
      title: 'Share Cart 💕',
      url: url,
      waText: 'Hey! Check out my pink picks from Mamacita in Pink 💕 ' + url,
      toastText: 'Your pink picks are ready to share 💕'
    });
  });
}

/* Share Wishlist — encodes product handles in the URL; the wishlist page
   reads the ?wl= param and renders a read-only shared view (no account
   or private data required to view it). */
function mipShareWishlist(handles) {
  if (!handles || !handles.length) return;
  var url = window.location.origin + '/pages/wishlist?wl=' + encodeURIComponent(handles.join(','));
  mipOpenShareSheet({
    title: 'Share Wishlist 💕',
    url: url,
    waText: "Hey! Here's my Mamacita in Pink wishlist 💕 " + url,
    toastText: 'Your wishlist is ready to share 💕'
  });
}

/* ===================== WhatsApp link helpers =====================
   Every wa.me link in the theme is built here, through one code path,
   using JS's encodeURIComponent — the only encoding method that reliably
   preserves emoji, line breaks, and multi-byte characters in a wa.me
   "text" query param. Liquid's server-side url_encode filter is
   intentionally NOT used for prefilled WhatsApp text, since mixing
   encoding strategies is what causes emoji to render as broken symbols
   on some devices. */
function mipWaUrl(number, text) {
  number = (number || '').replace(/[^0-9]/g, '');
  return 'https://wa.me/' + number + (text ? '?text=' + encodeURIComponent(text) : '');
}

/* Sets the floating WhatsApp button's href from theme settings once the
   page loads, so its emoji-bearing default message is always encoded by
   the same reliable JS path (rather than Liquid's url_encode). */
function mipInitFabWhatsapp() {
  var fab = document.getElementById('mipFabWhatsapp');
  if (!fab || !window.mipShop) return;
  fab.href = mipWaUrl(window.mipShop.whatsappNumber, window.mipShop.whatsappDefaultMessage);
}
document.addEventListener('DOMContentLoaded', mipInitFabWhatsapp);

/* ===================== Complete Order via WhatsApp ===================== */
function mipWhatsappCheckout() {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    if (!cart.items.length) return;

    var lines = cart.items.map(function (it, i) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? ' — ' + it.variant_title : '';
      return (i + 1) + '. ' + it.product_title + variant + ' — Qty ' + it.quantity + ' — ' + kes(it.final_line_price);
    });

    var intro = (window.mipShop && window.mipShop.whatsappCheckoutIntro) || "Hi Mamacita! I'd like to complete this order via WhatsApp 💕";
    var parts = [intro, '', 'My Pink Picks'].concat(lines).concat(['', 'Subtotal: ' + kes(cart.items_subtotal_price)]);

    var method = document.querySelector('input[name="cdMethod"]:checked');
    if (method) {
      parts.push('Fulfilment: ' + method.value);
      if (method.value === 'Nairobi Delivery') {
        var d = document.getElementById('cdNbDate').value, s = document.getElementById('cdNbSlot').value;
        if (d) parts.push('Date: ' + mipFormatLongDate(d));
        if (s) parts.push('Time Slot: ' + s);
        var giftEl = document.getElementById('cdGift');
        if (giftEl && giftEl.checked) {
          var gn = document.getElementById('cdGiftName').value, gm = document.getElementById('cdGiftMsg').value;
          parts.push('Gift: Yes');
          if (gn) parts.push('Gift Recipient: ' + gn);
          if (gm) parts.push('Gift Message: ' + gm);
        }
      } else if (method.value === 'Countrywide Delivery') {
        var cd = document.getElementById('cdCoDate').value;
        if (cd) parts.push('Dispatch Date: ' + mipFormatLongDate(cd));
      } else {
        var loc = document.querySelector('input[name="cdPuLoc"]:checked');
        var pd = document.getElementById('cdPuDate').value;
        if (loc) parts.push('Pickup Location: ' + loc.value);
        if (pd) parts.push('Pickup Date: ' + mipFormatLongDate(pd));
      }
    }
    var noteEl = document.getElementById('cdGiftMsg');
    if (noteEl && noteEl.value && (!method || method.value !== 'Nairobi Delivery')) parts.push('Order Note: ' + noteEl.value);

    parts.push('', window.location.origin + '/cart');

    var msg = parts.join('\n');
    var number = (window.mipShop && window.mipShop.whatsappNumber) || '254720177383';
    window.open(mipWaUrl(number, msg), '_blank');
  });
}
